import styled, { css } from 'styled-components';
import { AVATAR_SIZES } from '../../Constants';
export default styled.div.withConfig({
  displayName: "AvatarWrapper",
  componentId: "sc-1huaxqb-0"
})(["box-sizing:content-box;display:inline-flex;position:relative;transition-delay:150ms;transition:margin ease 300ms;flex-shrink:0;", " ", ""], ({
  $size
}) => $size === AVATAR_SIZES.responsive ? css(["inline-size:100%;aspect-ratio:1 / 1;"]) : '', ({
  $cssStyles
}) => $cssStyles);